import { Platform } from "react-native";
import { HeaderBackButton, HeaderBackButtonProps } from "@react-navigation/elements";
import { ParamListBase } from "@react-navigation/routers";
import type { NativeStackNavigationOptions, NativeStackNavigationProp } from "@react-navigation/native-stack";

import { colors } from "../../theme";
import { RouteProp } from "@react-navigation/native";
import { Feather } from "@expo/vector-icons";

const inkDarkest = colors.ink.darkest;

const BackButton = (props: HeaderBackButtonProps) => (
  <HeaderBackButton
    style={{ marginLeft: Platform.select({ android: -4, default: 0 }) }}
    tintColor={inkDarkest}
    backImage={({ tintColor }) => <Feather size={36} color={tintColor} name="chevron-left" />}
    labelVisible={false}
    {...props}
  />
);

type ScreenOptionsOverrides = Omit<NativeStackNavigationOptions, "headerLeft">;

export type ScreenOptionsFnProps<ParamList extends ParamListBase> = {
  route: RouteProp<ParamList>;
  navigation: NativeStackNavigationProp<ParamList>;
};

export function screenOptions<ParamList extends ParamListBase>(overrides: ScreenOptionsOverrides = {}) {
  return ({ route, navigation }: ScreenOptionsFnProps<ParamList>): NativeStackNavigationOptions => {
    function onPress() {
      if (navigation.canGoBack()) navigation.goBack();
    }

    return {
      headerLeft: (props: HeaderBackButtonProps) => (
        <BackButton {...props} onPress={onPress} testID={`header-back-button-${route.name}`} />
      ),
      ...overrides,
    };
  };
}

export const headerScreenOptions = screenOptions({
  headerBackTitleVisible: false,
  headerTintColor: inkDarkest,
  headerTitleStyle: { fontWeight: "normal" },
  headerShadowVisible: false,
});
